import { CurrencyValue } from '../../../common/currencyValue';
import BllinkUtils from '../../../common/utils/utils';
import Checkbox from '../../../common/simple/Checkbox';

const Time = BllinkUtils.BllinkTime;

const SpecialPaymentItem = ({ paymentItem, onChange }) => {
    const date = new Date(paymentItem.payment.createdAt);

    return (
        <div className='payment-item'>
            <div className='checkbox-wrapper'>
                <Checkbox
                    checked={paymentItem.isChecked}
                    onChange={() => onChange(paymentItem)}
                />
                <div className='payment-info'>
                    <div className='type'>{paymentItem.payment.payment_description}</div>
                    {date.getFullYear()}
                </div>
            </div>
            <CurrencyValue notInCents={true} currency={paymentItem.payment?.amount_left?.currency}>{paymentItem.payment?.amount_left?.value}</CurrencyValue>
        </div>
    )
}

export default SpecialPaymentItem;
